import React from 'react';
import '../../styles/layout/Clearfix.css';
const Clearfix = () => (
    <div className="clearfix" />
);
export default Clearfix;
